module.exports = __webpack_public_path__ + "assets/block3.fb798cac.png";